
import {GET_ROBOT_LOGS_ERROR} from "../../../reducers/robotReducer";


export const getRobotLogsError = (error) =>{
    return {
        type: GET_ROBOT_LOGS_ERROR,
        payload: {error}
    }
}